<template>
  <a-drawer width='35%' :label-col='4' :wrapper-col='14' :visible='open' @close='onClose'>
    <a-divider orientation='left'>
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref='form' :model='form' :rules='rules'>
      <a-form-model-item label='优惠券序列号' prop='couponNum' >
        <a-input :disabled='formType==2' v-model='form.couponNum' placeholder='请输入优惠券序列号(32)' :maxLength='32'/>
      </a-form-model-item>
      <a-form-model-item label='会员月份时长' prop='month' >
        <a-input-number v-model='form.month' placeholder='请输入会员时长（月）' :min='1' :maxLength='10' :max='1200'/>
      </a-form-model-item>
      <a-form-model-item label='是否已核销' prop='useFlag'>
        <switch-pack  v-model="form.useFlag"></switch-pack>
        <!--        <a-input v-model='form.useFlag' placeholder='请输入是否有用：0-不启用 1-启用' />-->
      </a-form-model-item>
      <div class='bottom-control'>
        <a-space>
          <a-button type='primary' :loading='submitLoading' @click='submitForm'>
            保存
          </a-button>
          <a-button type='dashed' @click='cancel'>
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCoupon, addCoupon, updateCoupon } from '@/api/coupon/coupon'
import SwitchPack from '@/components/crud/form/SwitchPack.vue'

export default {
  name: 'CreateForm',
  props: {}
  ,
  components: { SwitchPack }
  ,
  data() {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        couponNum: null,
        month: null,
        useFlag: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        couponNum: [
          {
            required: true, message: '优惠券序列号不能为空', trigger: 'blur'
          }
        ],
        month: [
          {
            required: true, message: '会员时长不能为空', trigger: 'blur'
          }
        ]
      }
    }
  }
  ,
  filters: {}
  ,
  created() {
  }
  ,
  computed: {}
  ,
  watch: {}
  ,
  mounted() {
  }
  ,
  methods: {
    onClose() {
      this.open = false
    }
    ,
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    }
    ,
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        couponNum: null,
        month: null,
        useFlag: 0
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    }
    ,
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    }
    ,
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCoupon({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    }
    ,
    /** 提交按钮 */
    submitForm: function() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateCoupon(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCoupon(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
